import React from 'react';
import { Eye20Regular } from '@fluentui/react-icons';
import { readersFromFile } from '../liveData';
import styles from '../css/vdr.module.css';

const FileReadsIndicator = ({ file, projectUsersAll }) => {
    const reads = Array.isArray(file?.read_by) ? file.read_by.length : Number(file?.read_by) || 0;
    if (reads <= 0) return '—';

    const readers = readersFromFile(file, projectUsersAll);

    return (
        <div
            className={styles.readsCell}
            onClick={e => e.stopPropagation()}
            onMouseDown={e => e.stopPropagation()}
        >
            <span className={styles.readsIndicator}>
                <Eye20Regular fontSize={16} />
                {reads}
            </span>
            <div className={styles.readsTooltipBody} role="tooltip">
                {(readers.length > 0 ? readers : [{ id: 'unknown', name: 'Unknown reader', lastRead: null }]).map(reader => {
                    const date = reader.lastRead && reader.lastRead !== '—' ? reader.lastRead : null;
                    return (
                        <p key={reader.id}>
                            {reader.name}
                            {date ? <span className={styles.readsTooltipDate}> · {date}</span> : null}
                        </p>
                    );
                })}
            </div>
        </div>
    );
};

export default FileReadsIndicator;
